var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('date-time-filter',{staticClass:"mb-3",model:{value:(_vm.dtRange),callback:function ($$v) {_vm.dtRange=$$v},expression:"dtRange"}}),_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }